import { render, staticRenderFns } from "./TheSimple.vue?vue&type=template&id=254261fa&scoped=true&lang=pug&"
import script from "./TheSimple.vue?vue&type=script&lang=js&"
export * from "./TheSimple.vue?vue&type=script&lang=js&"
import style0 from "./TheSimple.vue?vue&type=style&index=0&id=254261fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254261fa",
  null
  
)

export default component.exports